import ControlEffectivenessTesting from './OperationalEffectiveness/OperationalEffectivenessTesting';

export default ControlEffectivenessTesting;
